iScreenWizard.controller('TestafnameSelectorController', function ($scope, $state, $mdDialog, $filter, Ajax, ErrorHandler, Dictionary, userService, Testafnamestatus, Testafname, nieuwe360FeedbackService) {

    var pagesize = 20;

    $scope.userService = userService;
    $scope.feedback = nieuwe360FeedbackService.model;

    $scope.testafnamestatussen = [];

    $scope.searchTerm = '';
    $scope.aanmaakdatum_totenmet = new Date();
    $scope.aanmaakdatum_van = new Date(
        $scope.aanmaakdatum_totenmet.getFullYear()-1,
        $scope.aanmaakdatum_totenmet.getMonth(),
        $scope.aanmaakdatum_totenmet.getDate()
    );

    $scope.testafnames = [];
    $scope.testafnameFilters = {};
    $scope.testafnamePage = 1;
    $scope.testafnameMorePages = true;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        $scope.loadTestafnames();

        Testafnamestatus.all().then(function(testafnamestatussen) {
            angular.forEach(testafnamestatussen, function(testafnamestatus) {
                $scope.testafnamestatussen[testafnamestatus.id] = testafnamestatus;
            });
        });
    };

    $scope.loadMoreTestafnames = function() {
        $scope.testafnamePage = $scope.testafnamePage+1;
        $scope.loadTestafnames();
    };

    $scope.loadTestafnames = function() {
        params = {
            voor_wizardfeedback_rapporttemplate_id: $scope.feedback.rapporttemplate_id,
            pagesize: pagesize,
            page: $scope.testafnamePage,
            orderby: 'id',
            orderdesc: true
        };
        if ($scope.searchTerm.length > 0) {
            params.searchterm = $scope.searchTerm;
        }
        if ($scope.aanmaakdatum_van) {
            params.aanmaakdatum_van = $filter('date')(new Date($scope.aanmaakdatum_van),'dd-MM-yyyy');
        }
        if ($scope.aanmaakdatum_totenmet) {
            params.aanmaakdatum_totenmet = $filter('date')(new Date($scope.aanmaakdatum_totenmet),'dd-MM-yyyy');
        }
        Testafname.all(params).then(function (testafnames) {
            angular.forEach(testafnames, function(testafname) {
                $scope.testafnames.push(testafname);
            });
            if (testafnames.length < pagesize) {
                $scope.testafnameMorePages = false;
            }
        });
    };

    $scope.searchKandidaten = function() {
        $scope.testafnames = [];
        $scope.testafnameMorePages = true;
        $scope.testafnamePage = 1;
        $scope.loadTestafnames();
    };

    $scope.selectTestafname = function(testafname) {
        nieuwe360FeedbackService.model.brontestafname = testafname;
        nieuwe360FeedbackService.model.brontestafname_id = testafname.id;
        nieuwe360FeedbackService.SaveState();
        $state.go('360-feedback/feedbackgevers');
    };

});